import React, { forwardRef } from 'react'

import { IconProps } from './types'

const UserAdd = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.00001 13.4999L2.50221 13.4531L2.45081 13.9999H3.00001V13.4999ZM9.20775 9.48385L9.69168 9.60965L9.94335 8.64185L9.45948 8.51599L9.20775 9.48385ZM8.33335 13.9999H8.83335V12.9999H8.33335V13.9999ZM6.5409 8.51599L6.05699 8.64185L6.30869 9.60965L6.79261 9.48385L6.5409 8.51599ZM12.6667 10.1666V9.66658H11.6667V10.1666H12.6667ZM11.6667 14.1666V14.6666H12.6667V14.1666H11.6667ZM10.1667 11.6666H9.66668V12.6666H10.1667V11.6666ZM14.1667 12.6666H14.6667V11.6666H14.1667V12.6666ZM10 4.33325C10 5.43782 9.10461 6.33325 8.00001 6.33325V7.33325C9.65688 7.33325 11 5.99011 11 4.33325H10ZM8.00001 6.33325C6.89541 6.33325 6.00001 5.43782 6.00001 4.33325H5.00001C5.00001 5.99011 6.34316 7.33325 8.00001 7.33325V6.33325ZM6.00001 4.33325C6.00001 3.22869 6.89541 2.33325 8.00001 2.33325V1.33325C6.34316 1.33325 5.00001 2.6764 5.00001 4.33325H6.00001ZM8.00001 2.33325C9.10461 2.33325 10 3.22869 10 4.33325H11C11 2.6764 9.65688 1.33325 8.00001 1.33325V2.33325ZM3.49782 13.5467C3.71953 11.1883 5.44964 9.37672 7.91021 9.33405L7.89288 8.33418C4.87147 8.38658 2.76662 10.6405 2.50221 13.4531L3.49782 13.5467ZM7.91021 9.33405C7.94001 9.33352 7.96995 9.33325 8.00001 9.33325V8.33325C7.96421 8.33325 7.92848 8.33358 7.89288 8.33418L7.91021 9.33405ZM8.00001 9.33325C8.21415 9.33325 8.42208 9.34645 8.62341 9.37185L8.74861 8.37972C8.50508 8.34899 8.25535 8.33325 8.00001 8.33325V9.33325ZM8.62341 9.37185C8.82475 9.39725 9.01968 9.43492 9.20775 9.48385L9.45948 8.51599C9.22935 8.45618 8.99215 8.41045 8.74861 8.37972L8.62341 9.37185ZM3.00001 13.9999H8.33335V12.9999H3.00001V13.9999ZM7.89288 8.33418C7.42088 8.34238 6.96895 8.40472 6.5409 8.51599L6.79261 9.48385C7.14228 9.39285 7.51548 9.34085 7.91021 9.33405L7.89288 8.33418ZM10.1941 8.76445C9.74508 8.57532 9.26121 8.44439 8.74861 8.37972L8.62341 9.37185C9.04675 9.42532 9.44208 9.53278 9.80595 9.68605L10.1941 8.76445ZM11.6667 10.1666V12.1666H12.6667V10.1666H11.6667ZM11.6667 12.1666V14.1666H12.6667V12.1666H11.6667ZM10.1667 12.6666H12.1667V11.6666H10.1667V12.6666ZM12.1667 12.6666H14.1667V11.6666H12.1667V12.6666Z"
        fill={color}
      />
    </svg>
  ),
)

UserAdd.displayName = 'UserAdd'

UserAdd.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default UserAdd
